var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.path === `/${_vm.path}`)?_c('header',{staticClass:"details-header layout-header"},[_c('van-icon',{attrs:{"name":"arrow-left"},on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('b',[_vm._v(_vm._s(_vm.headerTitle))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }